import { render, staticRenderFns } from "./nurse.vue?vue&type=template&id=b0bef1ce&scoped=true"
import script from "./nurse.vue?vue&type=script&lang=js"
export * from "./nurse.vue?vue&type=script&lang=js"
import style0 from "./nurse.vue?vue&type=style&index=0&id=b0bef1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bef1ce",
  null
  
)

export default component.exports